// extracted by mini-css-extract-plugin
export default {"Options":"ConsultantMultiAcceptConfirmModal_Options__nWszi"};